<!-- 小程序列表 -->
<template>
<div id="xcx-list">
	<div style="background-color: #fff;padding: 15px 15px 5px;margin-bottom: 15px;">
		<!-- 标题 -->
		<div class="page-title" style="margin-bottom: 10px;">小程序列表</div>
		<div style="display: flex;align-items: flex-start;">
			<div style="flex: 1;">
				<a-row type="flex" justify="start" style="align-items: center;">
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">小程序名称</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-input v-model="r_applets_name" allowClear placeholder="请输入" style="width: 100%;"/>
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">所属渠道</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-select
									mode="multiple"
									style="width: 100%;"
									placeholder="请选择所属渠道"
									@change="handleChangeA"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
									allowClear
								  >
									<a-select-option v-for="(value,key) in zhChannelSelect" :key="key" :value="key">
									  {{value}}
									</a-select-option>
								</a-select>
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">平台</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-select
									style="width: 100%;"
									placeholder="请选择平台"
									@change="handleChangeC"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
									allowClear
								  >
									<a-select-option :value="1">微信小程序</a-select-option>
									<a-select-option :value="2">抖音小程序</a-select-option>
								</a-select>
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">APPID</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-input v-model="r_appid" allowClear placeholder="请输入" style="width: 100%;"/>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</div>
			
			<div style="width: 195px;border-left: 1px solid #e5e6eb;padding-left: 12px;">
				<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="margin-bottom-15" style="margin-right: 15px;">搜索</a-button>
				<a-button @click="addButton" type="primary" icon="plus" class="margin-bottom-15">新增</a-button>
			</div>
		</div>
	</div>
	
	<div style="background-color: #fff;padding-bottom: 30px;">
		<div style="padding: 10px;">
			<a-dropdown>
			    <a-menu slot="overlay" @click="handleMenuClick">
			        <a-menu-item key="1">
			          设置投手({{selectedData.length}})
			        </a-menu-item>
			    </a-menu>
			    <a-button> 批量操作 <a-icon type="down" /> </a-button>
			</a-dropdown>
		</div>
		
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell" style="justify-content: center;"
				:style="{'width':check_width + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index " class="table-th-cell"
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;" :style="{'height': item.height + 'px'}">
				<!-- 选择 -->
				<div class="table-td-cell" style="text-align: center;" :style="{'width':check_width + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'cz' && z_tem.type != 'platform' && z_tem.type != 'auth'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'platform'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" >
					{{item[z_tem.type] | platformFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'auth'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="color: #62a8ea;cursor: pointer;"
				 @click="setAuth(item)">
					<div v-if="item.auth.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;cursor: pointer;">
						<div v-for="(item,index) in item.auth" :key="index" style="color: #2F88FF;margin: 0 10px 5px 0">
							{{item.admin_name}}
						</div>
					</div>
					<div v-else style="color: #62a8ea;cursor: pointer;">
						未设置
					</div>
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'cz'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="color: #62a8ea;cursor: pointer;"
				 @click="editTable(item)">
					设置基础信息
				</div>
			</template>
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #f2f3f5;height: calc(100vh - 65px);width: 20px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #f2f3f5;height: calc(100vh - 65px);width: 20px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 新增和编辑的侧边栏 -->
	<a-drawer
	      :title="drawer_title"
		  width="600px"
	      placement="right"
	      :closable="false"
	      :visible="visible"
	      @close="onClose"
	    >
			<div style="padding: 10px;">
				<div class="form-cell-box" >
					<div class="class-title" >小程序名称<span class="required-hint">*</span></div>
					<a-input v-model="x_applets_name" allowClear placeholder="请输入" style="width: 340px;"/>
				</div>
				
				<div class="form-cell-box" >
					<div class="class-title" >所属渠道<span class="required-hint">*</span></div>
					<a-select
						style="width: 340px;"
						placeholder="请选择所属渠道"
						@change="handleChangeD"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						:value="x_channel"
					  >
						<a-select-option v-for="(value,key) in zhChannelSelect" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="form-cell-box" >
					<div class="class-title" >平台<span class="required-hint">*</span></div>
					<a-select
						style="width: 340px;"
						placeholder="请选择平台"
						@change="handleChangeE"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						:value="x_platform"
					  >
						<a-select-option :value="1">微信小程序</a-select-option>
						<a-select-option :value="2">抖音小程序</a-select-option>
					</a-select>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">小程序APPID<span class="required-hint">*</span></div>
					<a-input v-model="x_appid" allowClear placeholder="请输入" style="width: 340px;"/>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">小程序原始ID</div>
					<a-input v-model="x_origin_id" allowClear placeholder="请输入" style="width: 340px;"/>
				</div>
				
				<div class="form-cell-box" style="margin-top: 50px;">
					<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
					<a-button @click="onClose">取消</a-button>
				</div>
			</div>
	</a-drawer>
	
	<!-- 设置投手 -->
	<a-modal :visible="pl_modal" title="设置投手" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<!-- <div v-for="item in selectedData" :key="item.id" style="margin-bottom: 20px;">
				<span style="font-size: 15px;">小程序名称：{{item.applets_name}}</span>
			</div> -->
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的投手</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择投手"
					@change="handleChangeT"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
					:value="pl_value" 
					allowClear
				  >
					<template v-if="filterData.hasOwnProperty('op_id') && Object.keys(filterData.op_id).length > 0">
						<a-select-option v-for="(item,index) in filterData.op_id.list" :key="item.key" :value="item.key">
						  {{item.value}}
						</a-select-option>
					</template>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 150px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 12px;">{{item.label}}</div>
					<a-icon @click="delSelectAdmin(index)" type="close-circle" />
				</div>
			</div>
			
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的小程序名称：</div>
			<div style="max-height: 300px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<!-- <div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 130px;">{{item.applets_name}}</div> -->
					<div style="margin-right: 5px;">
						<a-tag>{{item.applets_name}}</a-tag>
					</div>
				</div>
			</div>
		</div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { putDataMenu, getXcxList, xcxListAdd, xcxListEdit, xcxListSetUser } from '@/request/api'
export default {
	name: 'xcxList_',
	components: {
	},
	data() {
		return {
			col_left_span: 7,
			col_content_span: 17, 
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", },
				{title:"小程序名称", width:120, type:"applets_name", },
				{title:"所属渠道", width:150, type:"plat_channel", },
				{title:"平台", width:120, type:"platform", },
				{title:"APPID", width:160, type:"appid", },
				{title:"原始ID", width:120, type:"origin_id", },
				{title:"投手",width:150, type:"auth", },
				{title:"操作",width:100, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false,
			sticky_index: 1,
			check_width: 50,
			
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_applets_name: null, // 小程序名称
			r_appid: null, // 小程序appid
			r_platform: undefined, // 小程序平台
			r_channel: undefined, // 渠道id
			
			// 筛选条件部分
			filterData: {
				op_id: {}
			},
			zhChannelSelect: [], // 小说小程序渠道+短剧渠道合并到一起
			
			x_id: null,
			x_applets_name: null, // 小程序名称
			x_channel: undefined, // 渠道
			x_platform: undefined, // 小程序平台
			x_appid: null, // 小程序APPID
			x_origin_id: null, // 小程序原始ID
			
			drawer_title: "新增",
			add_button_loading: false,
			visible: false,
			
			// 设置投手
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			pl_value: undefined, // 选择框的默认值
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [],
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		console.log("table_info",table_info)
		that.body_width = table_info.body_width + 20
		that.table_scroll_width = table_info.table_width + 20
		that.table_null_width = table_info.null_width + 20
		
		putDataMenu().then(res=>{
			// console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
			
			let f_select = res.data.data.filter
			that.zhChannelSelect = { ...f_select.vd_channel.list, ...f_select.mp_book_channel.list }
		})
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeA(e){ // 小程序渠道
			this.r_channel = e
		},
		handleChangeC(e){ // 小程序平台
			this.r_platform = e
		},
		handleChangeD(e){ // 侧边栏-渠道
			this.x_channel = e
		},
		handleChangeE(e){ // 侧边栏-小程序平台
			this.x_platform = e
		},
		searchButton(type){
			let that = this
			that.search_button_loading = true
			if(type == "setTs"){
				that.selectedData = [] // 已选内容清空
			}
			else if(type != '分页'){
				that.selectedData = [] // 已选内容清空
				that.r_page = 1
			}
			
			getXcxList({
				page: that.r_page,
				limit: that.r_limit,
				
				applets_name: that.r_applets_name, // 小程序名称
				appid: that.r_appid, // 小程序appid
				platform: that.r_platform, // 小程序平台
				channel: that.r_channel, // 渠道id
			}).then(res=>{
				console.log("列表数据",res);
				that.search_button_loading = false
				that.table_total = res.data.data.total || 0
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false // 用于多选和单选
					})
					
					// 表格已选中的内容支持跨分页
					if(that.selectedData.length > 0){
						let ccc = true
						let iii = 0 // 用于判断是否全选
						data.forEach(res=>{
							that.selectedData.forEach(res_r=>{
								if(res.id === res_r.id){
									res.checked = true
									ccc = false
									iii = iii + 1
								}
							})	
						})
						console.log("iii",iii)
						if(iii === that.r_limit){ // 全选
							that.indeterminate = false
							that.checkAll = true
						}
						else {
							if(ccc){
								that.checkAll = false
								that.indeterminate = false
							}
							else {
								that.checkAll = false
								that.indeterminate = true
							}
						}
						
					}
					else {
						console.log("that.checkAll",that.checkAll)
						that.checkAll = false
						that.indeterminate = false
					}
					
					that.tableShowData = data
				}
				else {
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 新增
		addButton(){
			this.visible = true
		},
		// 表格内的编辑按钮
		editTable(item){
			console.log("编辑item",item);
			this.drawer_title = "编辑"
			this.x_id = item.id
			this.x_applets_name = item.applets_name
			this.x_channel = item.channel.toString()
			this.x_platform = item.platform
			this.x_appid = item.appid
			this.x_origin_id = item.origin_id
			this.visible = true
		},
		addRequest(){
			let that = this
			
			if(!that.x_applets_name){
				that.$message.error(`请输入小程序名称`);
			}
			else if(!that.x_channel){
				that.$message.error(`请选择渠道`);
			}
			else if(!that.x_platform){
				that.$message.error(`请选择小程序平台`);
			}
			else if(!that.x_appid){
				that.$message.error(`请输入小程序APPID`);
			}
			else {
				this.add_button_loading = true
				let r_data = {
					applets_name: that.x_applets_name,
					channel: that.x_channel,
					platform: that.x_platform,
					appid: that.x_appid,
					origin_id: that.x_origin_id,
				}
				if(that.drawer_title == "新增"){
					xcxListAdd(r_data).then(res=>{
						console.log("新增",res)
						that.add_button_loading = false
						if(res.data.code == 0){
							that.$message.success('新增成功');
							
							that.onClose()
							
							that.searchButton()
						}
						else {
							if(res.data.code === 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(res.data.msg || "新增失败");
							}
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					r_data.id = that.x_id
					xcxListEdit(r_data).then(res=>{
						console.log("编辑",res)
						that.add_button_loading = false
						if(res.data.code == 0){
							that.$message.success('编辑成功');
							
							that.onClose()
							
							that.searchButton()
						}
						else {
							if(res.data.code === 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(res.data.msg || "编辑失败");
							}
						}
					})
				}
			}
			
			
		},
		onClose(){
			this.visible = false
			this.add_button_loading = false
			
			this.drawer_title = "新增"
			this.x_id = null
			this.x_applets_name = null
			this.x_channel = undefined
			this.x_platform = undefined
			this.x_appid = null
			this.x_origin_id = null
		},
		
		// 设置投手
		setAuth(e){
			console.log(e)
			this.selectedData = []
			this.selectedData.push(e)
			// for (let key in e.admin_user) {
			// 	let obj = {
			// 		label: e.admin_user[key],
			// 		key
			// 	}
			// 	this.pl_select_admin.push(obj)
			// }
			e.auth.forEach(res=>{
				let obj = {
					label: res.admin_name,
					key: res.admin_id
				}
				this.pl_select_admin.push(obj)
			})
			this.pl_modal = true
		},
		// 批量设置投手，选择投手
		handleChangeT(e){
			// console.log(e);
			this.pl_value = e
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		// 批量设置投手弹窗确认按钮
		plOk(){
			let that = this
			// if(that.pl_select_admin.length > 0){ // 得选择投手。投手可以为空
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.id)
				})
				console.log("i_data",i_data);
				
				xcxListSetUser({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						console.log("批量设置投手",res);
						that.selectedData = []
						that.plCancel()
						that.$message.success('设置成功');
						that.searchButton("setTs")
					}
					else {
						that.search_button_loading = false
						
						that.$message.error(`错误：${res.data.msg}`);
					}
				})
			// }
			// else {
			// 	this.$message.warning('请先选择投手');
			// }
			
			
		},
		// 删除选择的投手
		delSelectAdmin(index){
			this.pl_select_admin.splice(index,1)
			this.pl_value = undefined
		},
		// 批量设置投手弹窗取消按钮
		plCancel(){
			if(this.pl_loading){
				return 
			}
			this.pl_select_admin = []
			this.pl_modal = false
			this.pl_value = undefined
			
			// this.selectedData = []
		},
		
		
		// 全选
		onCheckAllChange(e){
			console.log("全选",e.target.checked)
			let that = this
			if(!e.target.checked){
				console.log("取消全选")
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = e.target.checked
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				console.log("全选",that.selectedData)
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id == res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = e.target.checked
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
		},
		// 批量操作
		handleMenuClick(e){
			console.log("批量操作",e)
			if(e.key == "1"){
				if(this.selectedData.length > 0){
					this.pl_modal = true
				}
				else {
					this.$message.warning('内容不能为空');
				}
			}
		}
	},
	filters: {
		platformFilters(value){
			let vvv = ""
			if(value == 1){
				vvv = "微信小程序"
			}
			else if(value == 2){
				vvv = "抖音小程序"
			}
			return vvv
		}
	}
}
</script>

<style scoped>
#xcx-list {
	background-color: rgb(240, 242, 245);
	margin: -20px -30px -30px -30px;
	padding: 20px 20px 30px 20px;
	min-height: calc(100vh - 65px);
}

.table-th-cell-sticky,.table-td-cell-sticky {
	left: 20px;
}
</style>